import React from 'react';

interface HighlightMatchProps {
  query: string;
  text: string;
}

const HighlightMatch = ({ query, text }: HighlightMatchProps) => {
  if (!query.trim() || !text) return <>{text}</>;

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escaped})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) => (
        regex.test(part)
          // eslint-disable-next-line react/no-array-index-key
          ? <mark key={i} style={{ backgroundColor: '#FFF8DD', fontStyle: 'normal', fontWeight: 'bold' }}>{part}</mark>
          // eslint-disable-next-line react/no-array-index-key
          : <span key={i}>{part}</span>
      ))}
    </>
  );
};

export default HighlightMatch;
